import { useActionsColumn } from '../../../../../../components/columns/actions';
import { ActionsDropdown } from '../../../../../../features/ActionsDropdown';

export function useLayoutActionsColumn() {
  return useActionsColumn({
    render: (text, row) => <ActionsDropdown table='layouts' row={row} />,
  });
}
